import React from "react";
import { useState } from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { pageNavigationPlugin } from "@react-pdf-viewer/page-navigation";

// import { Document, Page } from 'react-pdf';
const PdfPreview = ({ fileUrl }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const zoomPluginInstance = zoomPlugin();
  const pageNavigationPluginInstance = pageNavigationPlugin();
  return (
    <div
      style={{
        width: "800px",
        margin: "0 auto",
        border: "1px solid #0000001c",
        borderRadius: "8px",
        padding: "8px",
        boxSizing: "border-box",
        backgroundColor: "#f9f9f9",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "89vh",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}>
          <Viewer
            fileUrl={fileUrl}
            plugins={[
              defaultLayoutPluginInstance,
              zoomPluginInstance,
              pageNavigationPluginInstance,
            ]}
            defaultScale={1.0} // Set to 1.0 for actual size or 'PageFit' | 'PageWidth'
          />
        </Worker>
      </div>
    </div>
  );
};

export default PdfPreview;
{
  /* <Document file={fileUrl} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
                <Page pageNumber={pageNumber} />
            </Document> */
}
